// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","97":"desktop"}[chunkId] || chunkId) + "." + {"85":"2809fe76","97":"0b08e202","335":"86a2dfbf","822":"f502727d"}[chunkId] + ".chunk.js";
};